export class PendoService {
    constructor(pendoTrackFunction, defaultMetadata = {}) {
        this.pendoTrackFunction = pendoTrackFunction;
        this.defaultMetadata = defaultMetadata;
    }
    track(event) {
        const metadata = Object.assign(Object.assign({}, event.metadata), this.defaultMetadata);
        this.pendoTrackFunction(event.name, metadata);
    }
}
//# sourceMappingURL=pendo.service.js.map